export type { ApiClientDeps, FetchLike } from '@pay-roadrunner/api-client-core';
export { parseApiResponse } from '@pay-roadrunner/api-client-core';

export const jsonInit = (method: string, body: unknown): RequestInit => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});
